module.exports = __webpack_public_path__ + "media/assets/images/login_kousaku-161b52860db59e1b6c927d9130ebd2c3.png";